export var BulkSelectSnapshotStatus;
(function (BulkSelectSnapshotStatus) {
    BulkSelectSnapshotStatus["BULK_SELECT_SNAPSHOT_STATUS_OK"] = "BULK_SELECT_SNAPSHOT_STATUS_OK";
    BulkSelectSnapshotStatus["BULK_SELECT_SNAPSHOT_STATUS_NO_SNAPSHOT"] = "BULK_SELECT_SNAPSHOT_STATUS_NO_SNAPSHOT";
    BulkSelectSnapshotStatus["BULK_SELECT_SNAPSHOT_STATUS_NO_CLEAN_SNAPSHOT"] = "BULK_SELECT_SNAPSHOT_STATUS_NO_CLEAN_SNAPSHOT";
    BulkSelectSnapshotStatus["BULK_SELECT_SNAPSHOT_STATUS_ERROR"] = "BULK_SELECT_SNAPSHOT_STATUS_ERROR";
})(BulkSelectSnapshotStatus || (BulkSelectSnapshotStatus = {}));
